
export default {
  name: 'TeflVirtualVideo',
  props: {
    fallback: {
      type: String,
      default:'false'
    },
  },
  data() {
    return {
      isWistaLoaded: false,
      isVisible:false
    }
  },
  head() {
    const script = [];
    if (this.$props.fallback === 'true') {
      script.push(
        {
          hid: 'wista',
          src: "https://fast.wistia.net/assets/external/E-v1.js",
          async: true
        })

    }
    else if(this.isVisible){
      script.push(
        {
          src: 'https://fast.wistia.com/embed/medias/tz9s1h1vob.jsonp',
          async: true
        }, {
          hid: 'wista',
        src: 'https://fast.wistia.net/assets/external/E-v1.js',
        async: true,
          callback: () => { this.isWistaLoaded = true }
      }
      )
    }
    return {
      /* eslint-disable */
      script: script
      /* eslint-enable */
    }
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible
      console.log(isVisible, entry)
    }
  }
}
